import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgFilter = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.138 5.493A1 1 0 0 1 4 5h16a1 1 0 0 1 .874 1.486L16 15.259V19a1 1 0 1 1-2 0v-4a1 1 0 0 1 .126-.486L18.3 7H5.7l4.174 7.514A1 1 0 0 1 10 15v4a1 1 0 1 1-2 0v-3.74L3.126 6.485a1 1 0 0 1 .012-.993'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgFilter)
export default ForwardRef
